<template>
  <div>
    <label class="d-block">
      {{ $t(config.label) }}
    </label>
    <validation-provider
      :name="$t(`commands.data_types.${config.field_name}`)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        :options="options"
        v-model="model"
        :loading="loading"
        :clearable="true"
        :reduce="(item) => item.value"
        :multiple="multiple || multiple === 1"
        :calculate-position="calculatePosition"
        :append-to-body="appendToBody"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        @input="$emit('input', model)"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import axios from "@axios";

function buildAlarmOptionLabel(row) {
  const type = row.alarm_type != null ? String(row.alarm_type) : "";
  const unitLabel =
    row.unit && row.unit.address_1 != null ? String(row.unit.address_1) : "";
  const parts = [`#${row.id}`];
  if (type) {
    parts.push(type);
  }
  if (unitLabel) {
    parts.push(unitLabel);
  }
  return parts.join(" · ");
}

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: [Array, Object, Number, String],
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    calculatePosition: Function,
    appendToBody: Boolean,
  },
  data() {
    return {
      model: null,
      options: [],
      loading: false,
    };
  },
  created() {
    this.model = this.value;
  },
  watch: {
    value(next) {
      this.model = next;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const { data } = await axios.get("v1/alarm", {
        params: { max: 100, "page[n]": 1 },
      });
      const rows = data.data || [];
      this.options = rows.map((row) => ({
        value: row.id,
        label: buildAlarmOptionLabel(row),
      }));
    } finally {
      this.loading = false;
    }
  },
};
</script>
